import { Modal } from 'components/common';
import TeamSelectForm, { Team } from './TeamSelectForm';

interface JoinRequestModalProps {
  availableTeams: Team[];
  brokerageName?: string | null;
  hasBrokerage: boolean;
  disabled: boolean;
  onHideModal: () => void;
  onSubmit: (team: Team) => void;
  show: boolean;
}

const JoinRequestModal = ({
  availableTeams,
  brokerageName = null,
  hasBrokerage,
  disabled,
  onHideModal,
  onSubmit,
  show,
}: JoinRequestModalProps) => (
  <Modal centered onHide={onHideModal} scrollable={false} show={show}>
    <div className="p-4">
      <h4 className="fw-bold mb-3">{hasBrokerage ? 'Are you sure you want to switch teams?' : 'Select a team'}</h4>
      <div className="mb-3">
        {hasBrokerage
          ? `Once an admin accepts your request to switch teams, you will be removed from ${brokerageName ?? 'your current team'}.`
          : "After you send a request, you'll be added once an admin approves."}
      </div>
      <TeamSelectForm
        availableTeams={availableTeams}
        cancelLabel={hasBrokerage ? 'Stay on my team' : 'Cancel'}
        disabled={disabled}
        onCancel={onHideModal}
        onSubmit={onSubmit}
        resetKey={show}
        selectTestId="join-request-team-select"
        submitTestId="join-request-team-submit-button"
      />
    </div>
  </Modal>
);

export default JoinRequestModal;
